declare global {
  interface Window {
    appConfig: any;
  }
}

export class Environment {
  public production: boolean = false;

  public get config(): any {
    let appConfig = { production: this.production };
    return window.appConfig ? Object.assign({}, appConfig, window.appConfig) : appConfig;
  }
}

export const environment = new Environment();
